export const generateSearchQuery = (
  searchText: string,
  searchColumns: string[]
) => {
  const searchTextWords = searchText.split(" ");
  let query = "";

  for (let i = 0; i < searchTextWords.length; i++) {
    for (let j = 0; j < searchColumns.length; j++) {
      if (j === 0 && i === 0) {
        query += `&$filter=contains(${searchColumns[j]},'${searchTextWords[i]}')`;
      } else {
        query += ` or contains(${searchColumns[j]},'${searchTextWords[i]}')`;
      }
    }
  }
  return query;
};
